/* Hero product carousel: scroll-snap track + dots, prev/next (wrap-around) and
   gentle autoplay that pauses on hover/focus/drag and respects reduced motion.
   No external deps. Autoplay is opt-out via data-autoplay="false". */
(function () {
  document.querySelectorAll('[data-hero-carousel]').forEach(function (root) {
    var track = root.querySelector('[data-hero-track]');
    var prev = root.querySelector('[data-hero-prev]');
    var next = root.querySelector('[data-hero-next]');
    var dotsWrap = root.querySelector('[data-hero-dots]');
    if (!track) return;
    var slides = track.children;
    var count = slides.length;
    if (!count) return;

    var autoplay = root.getAttribute('data-autoplay') !== 'false';
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var timer = null;

    function step() {
      var gap = parseFloat(getComputedStyle(track).columnGap) || 16;
      return slides[0].getBoundingClientRect().width + gap;
    }
    function current() {
      return Math.min(count - 1, Math.max(0, Math.round(track.scrollLeft / step())));
    }
    function goto(i, smooth) {
      i = (i + count) % count;
      track.scrollTo({
        left: slides[i].offsetLeft - slides[0].offsetLeft,
        behavior: smooth === false ? 'auto' : 'smooth'
      });
    }
    function start() {
      if (!autoplay || reduce || count < 2 || timer) return;
      timer = window.setInterval(function () { goto(current() + 1); }, 5000);
    }
    function stop() {
      if (timer) { window.clearInterval(timer); timer = null; }
    }

    // Dots (built from the number of slides)
    var dots = [];
    if (dotsWrap) {
      for (var d = 0; d < count; d++) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'vlx-hero__dot';
        b.setAttribute('aria-label', 'Ir al producto ' + (d + 1));
        b.addEventListener('click', (function (idx) {
          return function () { stop(); goto(idx); };
        })(d));
        dotsWrap.appendChild(b);
        dots.push(b);
      }
    }
    function sync() {
      var i = current();
      for (var d = 0; d < dots.length; d++) {
        dots[d].classList.toggle('is-active', d === i);
      }
    }

    if (prev) prev.addEventListener('click', function () { stop(); goto(current() - 1); });
    if (next) next.addEventListener('click', function () { stop(); goto(current() + 1); });
    track.addEventListener('scroll', function () { window.requestAnimationFrame(sync); }, { passive: true });
    window.addEventListener('resize', function () { window.requestAnimationFrame(sync); });

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', start);
    track.addEventListener('pointerdown', stop);
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) { stop(); } else { start(); }
    });

    sync();
    start();
  });
})();
